export const isDeveloperWallet = (
  walletAddress?: string,
  developerWallets = process.env.NEXT_PUBLIC_DEV_WALLETS || ''
): boolean => {
  if (!walletAddress) {
    return false;
  }

  const normalizedWalletAddress = walletAddress.toLowerCase();

  return developerWallets
    .split(',')
    .some(
      (developerWallet) =>
        developerWallet.trim().toLowerCase() === normalizedWalletAddress
    );
};

export const getVaultListEndpoint = (
  walletAddress?: string,
  developerWallets = process.env.NEXT_PUBLIC_DEV_WALLETS || ''
): string =>
  isDeveloperWallet(walletAddress, developerWallets) ? '/devvaults' : '/vaults';
